import React from 'react'
import ContactForm from '../components/ContactForm'
import { companyInfo } from '../data'
import SubpageHero from '../components/SubpageHero'
import useMeta from '../hooks/useMeta'

export default function ContactPage() {
  useMeta(
    'Kontakt os',
    'Kontakt Matheus Cleaning Service for et uforpligtende tilbud på privat rengøring, housekeeping eller erhvervsrengøring. Vi svarer inden for 24 timer.'
  )

  const showCvr = companyInfo.cvr && companyInfo.cvr !== '0000000' && companyInfo.cvr !== ''

  return (
    <div className="flex flex-col bg-brand-light">
      {/* Main Content Section */}
      <section className="pt-16 md:pt-20 pb-24 md:pb-32">
        <div className="mx-auto max-w-7xl px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            {/* Contact Information Column */}
            <div className="lg:col-span-5 space-y-10 text-left">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-brand-navy tracking-tight">
                  Lad os tage os af rengøringen
                </h2>
                <p className="mt-3 text-sm text-brand-text-muted leading-relaxed">
                  Udfyld formularen til højre, ring til os eller send en e-mail – vi vender tilbage til dig hurtigst muligt og altid inden for 24 timer på hverdage.
                </p>
              </div>

              <div className="border-t border-neutral-200 pt-8 space-y-6">
                {/* Phone */}
                <div className="flex items-start gap-4">
                  <i className="fa-solid fa-phone text-black text-lg mt-0.5 shrink-0"></i>
                  <div>
                    <a
                      href={`tel:${companyInfo.phone.replace(/\s+/g, '')}`}
                      className="text-base font-semibold text-brand-navy hover:text-black transition-colors duration-150 block"
                    >
                      {companyInfo.phone}
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4">
                  <i className="fa-solid fa-envelope text-black text-lg mt-0.5 shrink-0"></i>
                  <div>
                    <a
                      href={`mailto:${companyInfo.email}`}
                      className="text-base font-semibold text-brand-navy hover:text-black transition-colors duration-150 block"
                    >
                      {companyInfo.email}
                    </a>
                  </div>
                </div>

                {/* Address */}
                <div className="flex items-start gap-4">
                  <i className="fa-solid fa-location-dot text-black text-lg mt-0.5 shrink-0"></i>
                  <div>
                    <p className="text-base font-semibold text-brand-navy">
                      {companyInfo.address}
                    </p>
                  </div>
                </div>

                {/* Opening Hours */}
                <div className="flex items-start gap-4">
                  <i className="fa-solid fa-clock text-black text-lg mt-0.5 shrink-0"></i>
                  <div>
                    <p className="text-base font-semibold text-brand-navy">
                      {companyInfo.openingHours}
                    </p>
                  </div>
                </div>

                {/* CVR */}
                {showCvr && (
                  <div className="flex items-start gap-4">
                    <i className="fa-solid fa-file-invoice text-black text-lg mt-0.5 shrink-0"></i>
                    <div>
                      <p className="text-base font-semibold text-brand-navy">
                        CVR: {companyInfo.cvr}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Contact Form Column */}
            <div className="lg:col-span-7">
              <ContactForm
                title="Send os en besked"
                subtitle="Udfyld formularen nedenfor med dine ønsker, så udarbejder vi et uforpligtende og skræddersyet tilbud til dig."
              />
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Image */}
      <div className="relative h-64 md:h-96 w-full overflow-hidden">
        <img
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/682e08ab-395d-4160-a58a-7bbf165ed9e3/close-up-cleaning-hero.jpg"
          alt="Professionel rengøring i et lyst og moderne hjem"
          className="w-full h-full object-cover block"
          loading="lazy"
        />
      </div>
    </div>
  )
}
